import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageHeading from "../../PageHeading";
import AllPageTable from "./AllPageTable";
import { useNavigate } from "react-router-dom";
import ConfirmActionModal from "../../ConfirmDeleteModal";

const AllPages = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedPageIds, setSelectedPageIds] = useState(null);

  const API_URL = "https://api.muktihospital.com/api/page";
  const navigate = useNavigate();

  // Fetch all pages
  useEffect(() => {
    const fetchPages = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL}?page=${page}&limit=${limit}&search=${search}`, {
          headers: { "x-api-key": "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079" },
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Failed to fetch pages");

        // console.log("API Response:", data);

        setPages(data.pages);
        setTotalPages(data.totalPages);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPages();
  }, [page, search]);

  // Open Delete Modal
  const openDeleteModal = (pageOrIds) => {
    if (Array.isArray(pageOrIds)) {
      setSelectedPageIds(pageOrIds);
    } else {
      setSelectedPageIds([pageOrIds.id]);
    }
    setShowDeleteModal(true);
  };

  // Close Delete Modal
  const closeDeleteModal = () => {
    setSelectedPageIds(null);
    setShowDeleteModal(false);
  };

  // Delete Page Function
  const handleDelete = async (ids) => {
    try {
      if (Array.isArray(ids)) {
        await Promise.all(
          ids.map((id) =>
            fetch(`${API_URL}/delete/${id}`, {
              method: "DELETE",
              headers: { "x-api-key": "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079" },
            }).then(async (response) => {
              const data = await response.json();
              if (!response.ok) throw new Error(data.error || "Failed to delete page");
              return data;
            })
          )
        );
        toast.success(`${ids.length} page${ids.length > 1 ? "s" : ""} deleted successfully!`);
      } else {
        const response = await fetch(`${API_URL}/delete/${ids}`, {
          method: "DELETE",
          headers: { "x-api-key": "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079" },
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Failed to delete page");
        toast.success("Page deleted successfully!");
      }
      setPages((prevPages) => prevPages.filter((page) => !ids.includes(page.id))); // Remove from UI
    } catch (error) {
      toast.error(error.message);
    }
  };

  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Manage Pages"},
    { label: "All Pages" },
  ];

  // Handle Edit
  const handleEdit = (id) => {
    navigate(`/edit-page/${id}`);
  };

  return (
    <div>
      <ToastContainer position="top-right" />
      {/* Delete Confirmation Modal */}
      <ConfirmActionModal
        isOpen={showDeleteModal}
        onClose={closeDeleteModal}
        onConfirm={handleDelete}
        ids={selectedPageIds}
        entityName="page"
        title="Confirm Delete"
        confirmText="Delete"
        cancelText="Cancel"
      />
      <PageHeading title="All Pages" breadcrumbs={breadcrumbs} />
      <AllPageTable
        data={pages}
        searchTerm={search}
        openDeleteModal={openDeleteModal}
        handleSearch={setSearch}
        handleEdit={handleEdit}
        loading={loading}
      />
    </div>
  );
};

export default AllPages;